<template>
    <ul class="language-chooser">
        <li v-for="(language, index) in languages" >    
            <a 
                href="#" 
                @click.prevent="setSystemLanguage(language.id)" 
                v-bind:class="{ active: (language.active) }"
            >
                {{ language.name}}
            </a>
            <span v-if="index !== (languages.length-1)">|</span>
        </li>
    </ul>
    </form>
</template>

<script>
    export default {
        name: 'language-selector',
        data: function(){
            return {
                languages: [
                    { name: 'English' , id: 'en', active: false},
                    { name: 'Español' , id: 'es', active: false }
                ]
            }
        },
        methods: {
            setSystemLanguage: function(languageId){
                var self = this;
                this.languages.map(function(language){
                    if(language.id === languageId){
                        language.active = true;
                        window.sessionStorage.setItem("language", language.id);
                        self.$root.$setLanguage(language.id);
                    }else{
                        //reset active status
                        language.active = false;
                    }
                })
            }
        },
        mounted: function(){
            if (this.$store.state.user !== undefined && this.$store.state.user != null && this.$store.state.user.available_languages !== undefined) {
                let languageOptions = this.$store.state.user.available_languages;

                this.languages = [];
                for (let key in this.languageOptions) {
                    this.languages.push({'id': key, 'name': languageOptions[key], 'active': false});
                }
            }

            var languageId = (this.$route.query.lang === undefined) ? 'en' : this.$route.query.lang; 
            this.setSystemLanguage(languageId);
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/language-selector.vue